import Vue from "vue";
// @ts-ignore
import VuetifyToast from "vuetify-toast-snackbar";

Vue.use(VuetifyToast, {
  timeout: 3000,
  dismissable: true,
  // autoHeight: true,
  // multiLine: true,
  // vertical: true, // default
  property: "$toast",
});
